"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Umbrella = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Umbrella = function Umbrella(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.6l.104.004C9.694 1.727 11.2 4.667 11.2 8.4c0 .232-.006.461-.017.687-.576-.661-1.415-.956-2.382-1.05L8.8 13.6a2.4 2.4 0 11-4.8 0v-.8a.8.8 0 011.6 0v.8a.8.8 0 001.595.093L7.2 13.6V8.036c-.967.095-1.807.39-2.383 1.05A14.116 14.116 0 014.8 8.4c0-3.733 1.506-6.673 3.096-6.796L8 1.6zm-2.06.284C4.778 3.214 4 5.634 4 8.4c0 .169.003.337.009.503C3.423 8.17 2.56 7.709 1.6 7.709c-.47 0-1.198.11-1.6.309.743-2.96 3.058-5.291 5.842-6.106l.098-.028zm4.12 0c2.827.788 5.189 3.14 5.94 6.134-.401-.199-1.13-.31-1.6-.31-.96 0-1.822.462-2.41 1.194.007-.166.01-.333.01-.502 0-2.766-.777-5.186-1.94-6.516zM8.103.016c.096.03.17.1.202.19l.218.61a8.12 8.12 0 00-1.043 0l.218-.611a.325.325 0 01.405-.19z",
    fill: "currentColor"
  }));
};

exports.Umbrella = Umbrella;
var _default = Umbrella;
exports.default = _default;